import AdminToolPage from "./AdminToolPage";

export default AdminToolPage;
export type { AdminToolPageProps } from "./AdminToolPage.types";
